import React, { useEffect } from 'react';
import { ToastContainer, ToastContainerProps, ToastContentProps, toast } from 'react-toastify';
import { useTheme } from '@emotion/react';
import { FormattedMessage } from 'react-intl';
import { SVGIcon, SVGIcons } from '@/components/atoms/Icon/SVGIcon';
import { NotificationWrapper, ContentContainer, HeaderContainer, Title } from './Notification.style';

type CustomNotificationProps = ToastContentProps<{
    title: string;
    content: string | React.ReactNode;
}>;

const CustomNotification = ({ data }: CustomNotificationProps) => {
    return (
        <NotificationWrapper>
            <ContentContainer>
                <HeaderContainer>
                    <Title>
                        <FormattedMessage id={data.title} />
                    </Title>
                    <SVGIcon icon={SVGIcons.INFO_V2} size={15} />
                </HeaderContainer>
                {data.content}
            </ContentContainer>
        </NotificationWrapper>
    );
};

export type NotificationProps = {
    title: string;
    content: string | React.ReactNode;
    toastProps?: ToastContainerProps;
};

const Notification = ({ title, content, toastProps }: NotificationProps) => {
    const theme = useTheme();

    const notify = () => {
        toast(CustomNotification, {
            data: {
                title,
                content,
            },
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            style: {
                backgroundColor: theme.color.red300,
            },
            closeButton: false,
            ...toastProps,
        });
    };

    useEffect(() => {
        notify();
    }, []);

    return <ToastContainer />;
};

export default Notification;
